import styled from "styled-components";
import { theme } from "../../constants/StyledComponents";

export const StyledTechSkills = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding-top: 20px;

  .tech-skills-header-container {
    display: flex;
    flex-direction: column;
    gap: 24px;
    align-items: end;
    margin-bottom: 20px;

    @media (max-width: ${theme.breakpoints.SM}px) {
      align-items: flex-start;
    }
  }

  & .search-container {
    width: 280px;
  }

  & .filters-container {
    align-items: center;

    display: flex;
    flex-direction: row;
    gap: 16px;
  }

  & .empty-state {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
  }
`;
